<div class="header-bar">
  <h1>My Schedule</h1>
</div>
<div class="content-container">
  <div class="card flex flex-column">
    <div class="sm:flex-order-1">
      <app-full-calendar
        [eventData]="events"
        (calendarEventChanged)="calendarEventChanged($event)"
        (calendarViewChanged)="calendarViewChanged($event)"
        (calendarDateClicked)="calendarDateClicked($event)"
        (calendarDayHeaderSelected)="calendarDayHeaderSelected($event)"
        (calendarVisibleDatesChanged)="calendarVisibleDatesChanged($event)"
      ></app-full-calendar>
      <div class="mt-2">
        <button
          pButton
          type="button"
          icon="pi pi-check"
          label="Done"
          class="ui-button-success pull-right"
          (click)="done()"
          style="margin-right: 0.25em"
        ></button>
      </div>
    </div>
    <div class="sm:flex-order-0 instruction">
      <h3 style="margin: 0px">
        Using the Availability Calendar <app-availability-help></app-availability-help>
      </h3>
      <div class="availability-info-container">
        <div class="flex grid-gap-10">
          <div class="flex-shrink-1 availability-info-icon">
            <i class="fa fa-info-circle" style="color: #012169"></i>
          </div>
          <div class="flex-grow-1">
            If you set yourself to Unavailable or Do Not Disturb, Juno will not generate routes for
            those days.
          </div>
        </div>
      </div>
      <ul>
        <li style="margin-bottom: 3px">
          Set Availability: Click on a date to toggle between 3 statuses.
        </li>
        <li><span class="available">Available</span> Open to work and receive job notifications</li>
        <li>
          <span class="unavailable">Unavailable</span> Not working but still open to notifications
          and contact from Engineius operations
        </li>
        <li>
          <span class="unavailable"><i class="fa fa-minus-circle"></i>&nbsp;Do Not Disturb</span> No
          job alerts or contact (e.g., holiday, personal leave).
        </li>
      </ul>
    </div>
  </div>
</div>

<p-dialog
  [(visible)]="showRangeSelectionDialog"
  [responsive]="true"
  [modal]="true"
  [closeOnEscape]="false"
  (onHide)="(!showRangeSelectionDialog)"
  header="Range Selection Action"
>
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <div class="grid">
      <div class="col-4 sm:col-3 md:col-2" style="margin-top: 30px">
        <i class="pi pi-calendar" style="font-size: 6em"></i>
      </div>
      <div class="col-8 sm:col-9 md:col-10 grid">
        <div class="mt-4 col-12">
          <p>
            You have selected the dates from
            {{ selectedDateRangeStart | datex : 'ddd DD MMM YYYY' }} until
            {{ selectedDateRangeEndDisplay | datex : 'ddd DD MMM YYYY HH:mm:ss' }}
          </p>
          <p>What would you like to do?</p>
        </div>
        <div class="col-4">
          <button
            type="button"
            pButton
            label="Set as Do Not Disturb"
            icon="fa fa-minus-circle"
            (click)="setDateRangeAvailability(availabilityStates.doNotDisturb)"
            class="ui-button red-btn w-full"
          ></button>
        </div>
        <div class="col-4">
          <button
            type="button"
            pButton
            label="Set as Unavailable"
            (click)="setDateRangeAvailability(availabilityStates.unavailable)"
            class="ui-button red-btn w-full"
          ></button>
        </div>
        <div class="col-4">
          <button
            type="button"
            pButton
            label="Set as Available"
            (click)="setDateRangeAvailability(availabilityStates.available)"
            class="ui-button green-btn w-full"
          ></button>
        </div>
      </div>
    </div>
  </div>
  <p-footer class="text-center mt-2">
    <button
      type="button"
      pButton
      label="Cancel"
      (click)="showRangeSelectionDialog = false"
      class="ui-button-secondary"
    ></button>
  </p-footer>
</p-dialog>
